import React from 'react';
import {useHistory} from 'react-router-dom';
import {t} from 'react-switch-lang';
import {format, parseISO} from 'date-fns';
import '../Dashboard.scss';
import NoFormTable from '../../../components/customTable/NoFormTable';

const Second = () => {
  const history = useHistory();


  const columns3 = [
    {
      key: 'id',
      dataIndex: ['risk', 'id'],
      title: t('last-court.operationalRiskId'),
      render: (dataIndex) => (
        <span style={{paddingLeft: '20px', paddingRight: '20px'}}>
          {dataIndex}
        </span>
      ),
    },
    {
      key: 'startingDateDispute',
      dataIndex: 'startingDateDispute',
      title: t('last-court.dateCreated'),
      render: (dataIndex) => (
        <span> {format(parseISO(dataIndex), 'dd.MM.yyyy.')} </span>
      ),
    },
    {
      key: 'bankLegitimation',
      dataIndex: 'bankLegitimation',
      title: t('last-court.bankLegitimation'),
    },
    {
      key: 'subjectDispute',
      dataIndex: 'subjectDispute',
      title: t('last-court.subjectOfDispute'),
    },
    {
      key: 'valueCourtDispute',
      dataIndex: 'valueCourtDispute',
      title: t('last-court.valueOfTheDispute'),
    },
    {
      key: 'jurisdiction',
      dataIndex: 'jurisdiction',
      title: t('last-court.jurisdiction'),
    },
    {
      key: 'feeReservation',
      dataIndex: 'feeReservation',
      title: t('last-court.reservedForLitigation'),
    },
    {
      key: 'provisionAmount',
      dataIndex: 'provisionAmount',
      title: t('last-court.reservedForReimbursement'),
    },
    {
      key: 'subjectStatus',
      dataIndex: 'subjectStatus',
      title: t('last-court.status'),
    },
    {
      key: 'value',
      title: t('last-potential-incurred.userCreated'),
      render: (request) => {
        return `${request.risk.userCreatedFirstName} ${request.risk.userCreatedLastName}`
      }
    },
  ];

  const toSingleRisk = (id) => {
    history.push(`/court-risk/${id}`);
  };
  return (
    <>
      <NoFormTable
        api={`court-risks/last-court?size=5`}
        columns={columns3}
        onRowClick={toSingleRisk}
        className={'table-hover'}
      />
    </>
  );
};

export default Second;
